"use client"

import { NuisibleFormFields } from "./components/nuisible-form-fields";
import { useNuisibleForm } from "./hooks/use-nuisible-form";

interface NuisibleFormProps {
  id?: string;
  nuisibleId?: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function NuisibleForm({ id, nuisibleId, onCancel, onSuccess }: NuisibleFormProps) {
  const {
    form,
    isSubmitting,
    error,
    isEditing,
    onSubmit,
  } = useNuisibleForm({
    id,
    nuisibleId,
    onSuccess,
  });

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <NuisibleFormFields
        form={form}
        error={error}
        isEditing={isEditing}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
      />
    </form>
  );
}
